import IconTargetedMarket from '../assets/icon_targeted_market.svg';
import IconGrowth from '../assets/icon_growth.svg';
import IconMarkets from '../assets/icon_markets.svg';
import IconPartner from '../assets/icon_partner.svg';
import IconChart from '../assets/icon_chart.svg';
import IconOffMarket from '../assets/icon_off_market.svg';
import IconBackground from '../assets/icon_background.svg';
import IconTrackRecord from '../assets/icon_trackrecord.svg';
import IconReferences from '../assets/icon_references.svg';
import ImgPanelOpportunity from '../assets/img_panel_opportunity.jpg';
import ImgPanelStairs from '../assets/img_panel_stairs.jpg';
import ImgPanelIncome from '../assets/img_panel_income.jpg';
import ImgPanelTenants from '../assets/img_panel_tenants.jpg';
import ImgPanelSiteVisit from '../assets/img_panel_sitevisit.jpg';
import people from '../ourStory/data/people';

export default {
  opportunity: {
    bg: 'white',
    heading: 'Evaluating an opportunity for investment',
    body: [
      'At RealtyMogul we provide due diligence on behalf of our investors and put every deal to the test against our most conservative financial models, which require unanimous approval from our investment committee.',
      'Every deal is evaluated against 4 core criteria and hundreds of data points to ensure only investments we believe are worth considering are made available to investors. Further, we provide investors with specific attributes of every deal on our website so investors who want to run their own due diligence can do so with ease.',
    ],
    image: ImgPanelOpportunity,
  },
  theMarket: {
    heading: 'The Market',
    body: [
      'The second area we review when looking at a real estate investment is the market of the property.',
      'Realtors often say that the only thing that matters is "location, location, location" and not without good reason.',
      'The market of an asset is of critical importance when determining whether to make an investment. A few areas we take into consideration are the demographics, economic trends, and comparables of the market.',
    ],
    insights: [
      {
        icon: IconTargetedMarket,
        heading: 'Demographics',
        text: 'Key factors we examine include items such as median household income, average age of population, and household formations.',
      },
      {
        icon: IconGrowth,
        heading: 'Economic Trends',
        text: 'We look for trends in the overall size of the market, property values, job, and industry growth.',
      },
      {
        icon: IconMarkets,
        heading: 'Comparables',
        text: 'We compare sales and lease information of properties within the submarket of the potential investment property to make sure we are in line, if not more conservatively written.',
      },
    ],
  },
  theInvestment: {
    heading: 'The Investment',
    body: [
      'In the final stages of our process, we spend time and resources negotiating the legal structure of an investment to put our investors first.',
      'There are several key provisions that we review when considering how the legal structure may contribute to the overall risks of a transaction.',
    ],
    insights: [
      {
        icon: IconPartner,
        heading: 'Operating Agreement',
        text: 'Our legal team works to ensure that our operating agreement accurately reflects the spirit of the partnership to mitigate risks in a variety of situations.',
      },
      {
        icon: IconChart,
        heading: 'Fees & Expenses',
        text: 'We analyze fees and expenses, both fixed fees and incentive based fees to understand the motives of the management team and negotiate on behalf of investors.',
      },
      {
        icon: IconOffMarket,
        heading: 'Asset Management',
        text: 'Our asset team steps in even before we close an investment as we believe active, disciplined management is essential throughout the life of all investments.',
      },
    ],
  },
  theProperty: {
    title: 'The Property',
    subtitle: "The third factor we consider is the quality of the property or asset. We evaluate the current physical condition and compare the information we gather with the real estate company's business plan to determine its viability. It is normal for our underwriting assumptions to adjust throughout this process to accurately represent our findings.",
    items: [
      {
        image: ImgPanelIncome,
        title: 'Income & Cost',
        body: 'We calculate the income potential of the property against expenses and compare to the market. We identify the replacement cost and any functional obsolescence.',
      },
      {
        image: ImgPanelTenants,
        title: 'Tenants & Rates',
        body: 'We look at the tenant population and determine if the property can meet their specific needs. We calculate vacancy and rental rates and compare the asset to the rest of the market.',
      },
      {
        image: ImgPanelSiteVisit,
        title: 'Site Visit',
        body: 'A member of our team steps foot on every property. An in-person visit to the property and surrounding area is a pre-requisite for any investment we decide to move forward with.',
      },
    ],
  },
  realEstateCompany: {
    title: 'The Real Estate Company',
    subtitle: 'The first thing we look at when analyzing an investment is the real estate company. The company is the individual or group of individuals who will acquire the real estate and execute on a business plan for the ownership. We consider multiple factors when evaluating a company to partner with.',
    items: [
      {
        image: IconBackground,
        title: 'Background',
        body: 'We conduct thorough background, criminal, and credit checks to identify any pending litigation or items of concern.',
      },
      {
        image: IconTrackRecord,
        title: 'Track Record',
        body: 'We examine all assets previously acquired and compare to the scope of the proposed project to ensure the requisite experience is in place to execute the proposed business plan.',
      },
      {
        image: IconReferences,
        title: 'References',
        body: 'We secure references from lenders, investors, and/or business associates and research the relationships with the property management company and leasing agents being used.',
      },
    ],
  },
  professionals: {
    section1: {
      bgImage: ImgPanelStairs,
      header: 'We step foot on every property',
      body: [
        'At RealtyMogul, we step foot on every property considered for investment.',
        'Once it is determined that each of the elements of a transaction are on balance and appear strong enough to accomplish the stated investment goals, we believe it is worth offering the investment in the property.',
      ],
    },
    section2: {
      topCard: {
        header: 'Save time & Resources',
        body: 'Our platform provides investors with convenient online due diligence packages for every deal.',
      },
      bottomCard: {
        header: 'Team up with professionals',
        body: 'From the originations and underwriting team, to the asset management group and our executive staff, you can rest assured we have the expertise for you to make investment decisions.',
      },
    },
  },
  team: {
    heading: 'Real Estate Team',
    items: [
      people.jillieneh,
      people.chrisf,
    ],
  },
};
